/* tslint:disable */
/* eslint-disable */
/**
 * MAPIIO API
 * API mapové aplikace Mapiio pro klientskou JavaScriptovou / React část.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



    /**
 * 
 * @export
 * @enum {string}
 */

export const EnumSearchTypes = {
    FEATURESEARCH: 'FEATURESEARCH',
    LOCATIONS_PREVIEW: 'LOCATIONS_PREVIEW',
    LAYERS: 'LAYERS'
} as const;

export type EnumSearchTypes = typeof EnumSearchTypes[keyof typeof EnumSearchTypes];



